var module = angular.module('octopusApp.projects');

module.directive('packageDownloadOptions', function() {
    return {
        restrict: 'E',
        replace: true,
        transclude: false,
        scope: {
            action: '=',
            localNames: '='
        },
        templateUrl: 'areas/projects/views/package_download_options.html',
        link: function(scope, element) {
            
            if (!scope.action.Properties["Octopus.Action.Package.DownloadOnTentacle"]) {
                scope.action.Properties["Octopus.Action.Package.DownloadOnTentacle"] = "False";
            }
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/package_download_options.js
// module id = 345307337391285
// module chunks = 1